import React from "react";
import { map, sumBy } from "lodash";
import styled from "styled-components";
import { content } from "@glossy";
import { percent } from "@tootools/number";
import Tooltip from "@ui-kit/tooltip";

export interface IProps {
  items: { color: string; amount: number }[];
  className?: string;
  tooltip?: (index) => React.ReactNode;
}

const Root = styled.div`
  overflow: hidden;
  height: 12px;
  border-radius: 6px;
  background-color: ${(props) => content(props, "tertiary")};
  font-size: 0;
`;

const Item = styled.div`
  height: 100%;
  display: inline-block;
`;

const UiKitGauge = ({ items, className, tooltip }: IProps) => {
  const total = sumBy(items, "amount");

  return (
    <Root className={className}>
      {map(items, ({ color, amount }, key) => (
        <Tooltip
          key={key}
          disabled={!!tooltip ? false : true}
          tooltip={!!tooltip && tooltip(key)}
          placement="top"
        >
          <Item
            key={key}
            style={{
              width: `${percent(amount, total)}%`,
              backgroundColor: color,
            }}
          ></Item>
        </Tooltip>
      ))}
    </Root>
  );
};

export default UiKitGauge;
